import { setConopsActivity_actionType } from "../constants";

const initialState = {
  activity: {},
};

const conopsReducer = (state = initialState, action) => {
  switch (action.type) {
    case setConopsActivity_actionType:
      return {
        ...state,
        activity: {
          ...state.activity,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};

export default conopsReducer;
